import Vue from 'vue'
import Vuex from 'vuex'
import Brows from '@/plugins/browser.js';
Vue.use(Vuex)
let store = new Vuex.Store({
  strict: true
})
store.registerModule('common', {
  state: {
    showdlg:false,
    zhulidlg:false,
    pageScrollTop: 0,
    isLoading: false,
    direction: 'forward',
    browser: ''
  },
  mutations: {
    updatazhulidlg(state,isshow){
      state.zhulidlg = isshow
    },
    updataShowDlg(state,isshow){
      state.showdlg = isshow;
    },
    updatePagePosition (state, payload) {
      state.pageScrollTop = payload.top
    },
    updateLoadingStatus (state, payload) {
      state.isLoading = payload.isLoading
    },
    updateDirection (state, payload) {
      state.direction = payload.direction
    },
    getbrowser(state) {
      state.browser = Brows();
    }
  },
  actions: {
    updatePagePosition ({commit}, top) {
      commit({type: 'updatePagePosition', top: top})
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js